var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetupBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 54H88V75C88 78.3137 85.3137 81 82 81H9C5.68629 81 3 78.3137 3 75V54Z",
    fill: "#6BE3A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 21V14C32 10.6863 34.6863 8 38 8H52C55.3137 8 58 10.6863 58 14V21",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 54V75C3 78.3137 5.68629 81 9 81H82C85.3137 81 88 78.3137 88 75V54M3 54V23C3 19.6863 5.68629 17 9 17H82C85.3137 17 88 19.6863 88 23V54M3 54H55.619M88 54H55.619M55.619 54V59C55.619 62.3137 52.9328 65 49.619 65H38.4167",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetupBusiness);
export default __webpack_public_path__ + "static/media/setup-business.15811020c02c36d01d1dd32d6b710655.svg";
export { ForwardRef as ReactComponent };